import { Button } from '@profitowi/component-library';
import { parse } from 'date-fns';
import { Cell, Column } from 'react-table';

import { DICTIONARY_TYPES } from 'constants/dictionaryTypes';
import useDictionaryContext from 'hooks/useDictionaryContext';
import { AgentDetailsBlockade } from 'types/agent';
import { parseActiveStatus } from 'utils/lingual';

export const createColumns: (
  setBlockadeToDelete: (blockade: AgentDetailsBlockade) => void,
  openDeleteBlockadeModal: () => void
) => Column<AgentDetailsBlockade>[] = (setBlockadeToDelete, openDeleteBlockadeModal) => {
  return [
    {
      Header: 'Typ blokady',
      id: 'type',
      Cell: ({
        row: {
          original: { type },
        },
      }: Cell<AgentDetailsBlockade>) => {
        const { translate } = useDictionaryContext();

        return type ? translate(DICTIONARY_TYPES.BLOCKER_TYPE, type) : '';
      },
    },
    {
      Header: 'Data od',
      id: 'createdAt',
      accessor: 'blockadeCreateDate',
      sortType: (a, b) =>
        parse(a.values.blockadeCreateDate, 'dd-MM-yyyy HH:mm:ss', new Date()).valueOf() -
        parse(b.values.blockadeCreateDate, 'dd-MM-yyyy HH:mm:ss', new Date()).valueOf(),
    },
    // Hide accountingDocumentNumber for now @PROFMP140-3
    // {
    //   Header: 'Numer dokumentu księgowego',
    //   id: 'accountingDocumentNumber',
    //   accessor: (row: AgentDetailsBlockade) => row?.accountingDocumentNumber || '',
    // },
    {
      Header: 'Data do',
      id: 'disableDate',
      accessor: 'blockadeDisableDate',
      sortType: (a, b) =>
        parse(a.values.blockadeDisableDate, 'dd-MM-yyyy HH:mm:ss', new Date()).valueOf() -
        parse(b.values.blockadeDisableDate, 'dd-MM-yyyy HH:mm:ss', new Date()).valueOf(),
    },
    {
      Header: 'Status blokady',
      id: 'valid',
      accessor: (row: AgentDetailsBlockade) => parseActiveStatus(!!row.valid, 'SHE'),
    },
    {
      id: 'operations',
      disableSortBy: true,
      Cell: ({ row: { original } }: Cell<AgentDetailsBlockade>) => {
        return (
          !!original.valid && (
            <div className="flex justify-end">
              <Button
                variant="light"
                onPress={() => {
                  setBlockadeToDelete(original);
                  openDeleteBlockadeModal();
                }}>
                <i className="bi bi-trash cursor-pointer" />
              </Button>
            </div>
          )
        );
      },
    },
  ];
};
